const featuredVideos = document.querySelectorAll('.trellis-component--featured-video');
featuredVideos.forEach((featuredVideo) => {
  featuredVideo.addEventListener('click', () => {
    // Hide the button
    const playVideoButton = featuredVideo.querySelector('.featured-video__video-placeholder');
    if (playVideoButton) playVideoButton.style = 'display: none;';

    // Grab the video to play
    const videoToPlay = featuredVideo.querySelector('.featured-video__video');

    // Play the video
    videoToPlay.play();
  });
});